"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const NavigateNext = createSvgIcon(
  <path d="M14.7019 12.0009L9.39422 17.3086L8.68652 16.6009L13.2865 12.0009L8.68652 7.40089L9.39422 6.69319L14.7019 12.0009Z" />,
  "NavigateNext",
)

const NavigateNextIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <NavigateNext sx={{ fill: _fill, ...sx }} {...rest} />
}

export default NavigateNextIcon
